import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { common } from '@qwyk/models';
import { environment } from '@qwyk/portals/environment';

@Injectable({
    providedIn: 'root',
})
export class CustomTagsService {

    private http = inject(HttpClient);

    public tagEntity(
        request: { data: Partial<common.CustomTag>[] }
    ): Observable<{ data: Partial<common.CustomTag[]> }> {
        return this.http
            .post<{ data: Partial<common.CustomTag[]> }>(
                `${
                    environment.backendServer
                }/api/portals/tags`,
                { ...request }
            )
            .pipe(take(1));
    }

    public linkTagToEntity(
        request: { entityId: string, tagId: string, type: string }
    ): Observable<common.CustomTag[]> {
        return this.http
            .patch<common.CustomTag[]>(
                `${
                    environment.backendServer
                }/api/portals/tags/${request.tagId}/${request.type}/${request.entityId}/link`,
                null
            )
            .pipe(take(1));
    }

    public unlinkTagFromEntity(
        request: { tagId: string, entityId: string, type: string }
    ): Observable<common.CustomTag> {
        return this.http
            .patch<common.CustomTag>(
                `${
                    environment.backendServer
                }/api/portals/tags/${request.tagId}/${request.type}/${request.entityId}/unlink`,
                null
            )
            .pipe(take(1));
    }

    public getCustomTagsByName(
        name: string
    ): Observable<common.SearchCustomTag[]> {
        return this.http
            .post<common.SearchCustomTag[]>(
                `${
                    environment.backendServer
                }/api/portals/tags/search`,
                { query: name }
            )
            .pipe(take(1));
    }

    getCustomTagsByNameQuery(query: any): Observable<common.PaginatedResponse<common.CustomTag>> {
        return this.http
            .get<common.PaginatedResponse<common.CustomTag>>(
                `${
                    environment.backendServer
                }/api/portals/tags?name=${query}`
            )
            .pipe(take(1));
    }

    public getCustomTagsPaginated(query: any): Observable<common.PaginatedResponse<common.CustomTag>> {
        return this.http
            .get<common.PaginatedResponse<common.CustomTag>>(
                `${
                    environment.backendServer
                }/api/portals/tags?${this.mapGetTagsQuery(query)}`
            )
            .pipe(take(1));
    }

    public updateCustomTag(
        request: Partial<common.CustomTag>
    ): Observable<common.CustomTag> {
        return this.http
            .patch<common.CustomTag>(
                `${
                    environment.backendServer
                }/api/portals/tags/${request.id}`,
                { ...request }
            )
            .pipe(take(1));
    }

    private mapGetTagsQuery(query: any): HttpParams {
        Object.keys(query).forEach(k => {
            if (query[k] === null) {
                delete query[k];
            } else {
                query[k] = query[k].toString();
            }
        });

        return new HttpParams({ fromObject: query });
    }
}
